// extracted by mini-css-extract-plugin
export default {"grid":"LayoutTilesView__grid--2pY"};